<ng-container *ngIf="initialized">

    <!--    1: {{this.modeHideFields}}-->
    <!--    2: {{showAllFields}}-->

    <!--    <p-button [label]="showAllFields ? 'All Fields' : 'Visible Fields'" (click)="toggleHiddenFields()"></p-button>-->
    <form [formGroup]="formGroup">
            <div formArrayName="widgetField">
                <div class="flex gap-4 mb-2 p-3 shadow-1">
                    <div>
                        <p-checkbox inputId="audit" name="audit" [binary]="true" (onChange)="onToggleAuditFields($event)"/>
                        <label for="audit" class="ml-1"> Audit Fields </label>
                    </div>

                    <div>
                        <p-checkbox inputId="foreign" name="foreign" [binary]="true" (onChange)="onToggleForeignIdFields($event)"/>
                        <label for="foreign" class="ml-1"> Foreign ID Fields </label>
                    </div>
                </div>
                <p-table [value]="widgetUiFields"
                         [contextMenu]="cmTable"
                         [reorderableColumns]="true"
                         [scrollable]="true"
                         scrollHeight="72vh"
                         class="table-gray-header"
                         (onRowReorder)="changeAttributePriority()">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                <i class="cursor pt-2"
                                   [ngClass]="!showFilterInput ? 'pi pi-filter' : 'pi pi-filter-slash text-primary'"
                                   (click)="handleShowFilterInput()"></i>
                            </th>

                            <th>
                                <div #fieldNameConfig class="flex flex-column gap-1">
                                    <span>  Feld </span>
                                    <!--                <p-divider layout="vertical" styleClass="mx-2 h-1rem"/>-->
                                    <!--                                  <i class="cursor"-->
                                    <!--                                     [ngClass]="showFilterInput ? 'pi pi-filter' : 'pi pi-filter-slash text-primary'" (click)="handleShowFilterInput()"-->
                                    <!--                                     ></i>-->
                                    <!--                                              <input *ngIf="showFilterInput" pInputText type="text" (input)="handleFilterField($event.target.value)"-->
                                    <!--                                                     placeholder="Search by Fled">-->

                                    <p-select *ngIf="showFilterInput"
                                              id="mood"
                                              [filter]="true"
                                              class="w-12rem"
                                              size="small"
                                              placeholder="Search by Field"
                                              optionLabel="label"
                                              optionValue="value"
                                              [options]="fieldNameOptions"
                                              [(ngModel)]="filters.fieldName"
                                              [ngModelOptions]="{standalone: true}"
                                              name="fieldName"
                                              (onChange)="applyFilters()"
                                              (onFilter)="onFieldFilter($event, 'fieldName')"
                                              appendTo="body"
                                              [showClear]="true">
                                    </p-select>

                                </div>
                                <p-contextMenu [appendTo]="'body'" [target]="fieldNameConfig"
                                               [model]="fieldNameContextMenu"></p-contextMenu>
                            </th>



                            <th>

                                <div class="flex flex-column gap-1">
                                    <span>Source</span>
                                    <p-select *ngIf="showFilterInput"
                                              [filter]="true"
                                              class="w-12rem"
                                              size="small"
                                              placeholder="Search by Source"
                                              [options]="sourceOptions"
                                              [(ngModel)]="filters.source"
                                              [ngModelOptions]="{standalone: true}"
                                              name="source"
                                              optionLabel="label"
                                              optionValue="value"
                                              (onChange)="applyFilters()"
                                              (onFilter)="onFieldFilter($event, 'source')"
                                              appendTo="body"
                                              [showClear]="true"
                                    >
                                    </p-select>
                                </div>

                            </th>
                            <th>
                                <div class="flex flex-column gap-1">
                                    <span> <i class="fa-regular fa-tag mr-1"></i> Label Name</span>
                                    <p-select *ngIf="showFilterInput"
                                              id="mood"
                                              [filter]="true"
                                              class="w-12rem" size="small" placeholder="Search by Label Name"
                                              optionLabel="label" optionValue="value"
                                              [options]="labelOptions"
                                              [(ngModel)]="filters.label"
                                              [ngModelOptions]="{standalone: true}"
                                              name="label"
                                              (onChange)="applyFilters()"
                                              (onFilter)="onFieldFilter($event, 'label')"
                                              appendTo="body"
                                              [showClear]="true"
                                    ></p-select>
                                </div>

                            </th>
                            <th>
                                <div class="flex flex-column gap-1">
                                    <span> Ausgabefeld</span>
                                    <p-select *ngIf="showFilterInput"
                                              id="mood"
                                              [filter]="true"
                                              class="w-12rem" size="small" placeholder="Search by Ausgabefeld"
                                              optionLabel="label" optionValue="value"
                                              [options]="outputFieldOptions"
                                              [(ngModel)]="filters.outputField"
                                              [ngModelOptions]="{standalone: true}"
                                              name="outputField"
                                              (onChange)="applyFilters()"
                                              (onFilter)="onFieldFilter($event, 'outputField')"
                                              appendTo="body"
                                              [showClear]="true"
                                    ></p-select>
                                </div>
                            </th>
                            <th>
                                <div class="flex gap-1 align-items-center">
                            <span #widgetConfigAll>
                                <i *ngIf="modeHideFields" (click)="toggleHideFields()"
                                   pTooltip="Feld ausblenden" tooltipPosition="top"
                                   class="fa-sharp fa-solid fa-eye-slash pointer"></i>
                                <i *ngIf="!modeHideFields" (click)="toggleHideFields()"
                                   pTooltip="Visible Fields" tooltipPosition="top"
                                   class="fa-sharp fa-solid fa-eye pointer"></i>
                            </span>
                                    @if (showFilterInput) {
                                        <p-divider layout="vertical" styleClass="mx-2 h-1rem"/>
                                        <!--  [pTooltip]="showAllFields ? 'All Fields' : 'Active Fields'"  tooltipPosition="top"-->
                                        <i class="cursor"
                                           [ngClass]="showAllFields ? 'pi pi-filter' : 'pi pi-filter-slash text-primary'"
                                           (click)="handleFieldFilterMode();"></i>

                                    }

                                </div>
                                <p-contextMenu [appendTo]="'body'" [target]="widgetConfigAll"
                                               [model]="selectAllContextMenu"></p-contextMenu>
                            </th>
                            <th>
                                <div class="flex gap-1 align-items-center">

                                    <span #widgetConfigAll2>
                                        <i class="fa-light fa-text-slash"
                                           pTooltip="Reihenfolge"
                                           tooltipPosition="top">
                                        </i>
                                    </span>
                                    @if (showFilterInput) {
                                        <p-divider layout="vertical" styleClass="mx-2 h-1rem"></p-divider>

                                        <i class="cursor"
                                           [ngClass]="showReorderFields ? 'pi pi-filter' : 'pi pi-filter-slash text-primary'"
                                           (click)="handleReorderFilterMode()">
                                        </i>

                                    }


                                </div>
                                <p-contextMenu [appendTo]="'body'" [target]="widgetConfigAll2"
                                               [model]="selectAllContextMenu"></p-contextMenu>
                            </th>
                            <th>
                                <div class="flex gap-1 align-items-center">

                                    <span #widgetConfigAll3>
                                        <i class="fa-solid fa-circle"
                                           pTooltip="Keine Anzeige bei NULL"
                                           tooltipPosition="top">
                                        </i>
                                    </span>

                                    @if (showFilterInput) {
                                        <p-divider layout="vertical" styleClass="mx-2 h-1rem"></p-divider>

                                        <i class="cursor"
                                           [ngClass]="showNullFields ? 'pi pi-filter' : 'pi pi-filter-slash text-primary'"
                                           (click)="handleNullFilterMode()">
                                        </i>

                                    }

                                </div>
                                <p-contextMenu [appendTo]="'body'" [target]="widgetConfigAll3"
                                               [model]="selectAllContextMenu"></p-contextMenu>
                            </th>
                            <th></th>

                        </tr>

                    </ng-template>
                    <ng-template pTemplate="body" let-i="rowIndex"
                                 let-rowData
                                 let-field
                                 let-rowIndex="rowIndex"
                                 let-expanded="expanded">
                        <tr [formGroup]="rowData"
                            [pReorderableRow]="rowIndex"
                            [pSelectableRow]="rowData"
                            [pContextMenuRow]="rowData"
                            (contextmenu)="onContextMenuField($event, rowData, rowIndex)"
                        >
                            <td><span class="pi pi-bars" pReorderableRowHandle></span></td>
                            <td>
                                <div style="min-width: 15rem;">
                                    <span *ngIf="fieldNameRegularView">{{ rowData.get('uiFieldLabel')?.value }}</span>
                                    <span *ngIf="!fieldNameRegularView">{{ rowData.get('field')?.value }}</span>
                                </div>

                            </td>

                            <td>
                                <div style="min-width: 15rem">{{ rowData.get('uiFieldReference')?.value }}</div>
                                @if (rowData.get('uiGenericTypeName')) {
                                    <small>{{ rowData.get('uiGenericTypeName')?.value }}</small>
                                }
                                @if(rowData.get('sourcePath')) {
                                    <small>{{ rowData.get('sourcePath').value }}</small>
                                }

                            </td>

                            <td><input class="w-auto" *ngIf="visibleFields['uiLabel']" pInputText type="text"
                                       formControlName="uiLabel"/>
                            </td>
                            <td>
                                <p-select
                                        *ngIf="visibleFields['uiOutputField']"
                                        appendTo="body" [filter]="true"
                                        class="output-field-dropdown"
                                        styleClass="w-12rem"
                                        formControlName="uiOutputField"
                                        [options]="optionsOutputFormFields"
                                        optionValue="id"
                                        optionLabel="label">

                                </p-select>
                            </td>

                            <td>
                                <p-toggle-switch
                                        *ngIf="visibleFields['uiHidden']"
                                        formControlName="uiHidden"></p-toggle-switch>
                            </td>
                            <td>
                                <p-toggle-switch
                                        *ngIf="visibleFields['uiShowLabel']"
                                        formControlName="uiShowLabel"></p-toggle-switch>
                            </td>
                            <td>
                                <p-toggle-switch
                                        *ngIf="visibleFields['uiHideNull']"
                                        formControlName="uiHideNull"></p-toggle-switch>
                            </td>
                            <td>
                                <button type="button" pButton pRipple
                                        (click)="toggleRowExpansion(rowData.get('field')?.value)"
                                        pTooltip="Expert Mode" tooltipPosition="top"
                                        class="p-button-text p-button-rounded p-button-plain"
                                        [icon]="rowExtensionOpen[rowData.get('field')?.value] ? 'pi pi-chevron-down' : 'pi pi-chevron-left'">
                                </button>
                            </td>
                        </tr>

                        <!-- Show expert mode fields -->
                        <ng-container *ngIf="rowExtensionOpen[rowData.get('field')?.value]">
                            <tr [formGroup]="rowData" style="background: var(--surface-100);">
                                <td colspan="20">

                                    <div class="grid m-0 p-5">
                                        <div
                                                *ngIf="visibleFields['uiInputField']"
                                                class="flex flex-column gap-1 col-3 mb-2">
                                            <label class="text-color-secondary">Input Fields</label>
                                            <p-select
                                                    appendTo="body" [filter]="true"
                                                    formControlName="uiInputField"
                                                    [options]="optionsInputFormFields"
                                                    styleClass="flex"
                                                    optionValue="id"
                                                    optionLabel="label">
                                            </p-select>
                                        </div>

                                        <div class="flex flex-column gap-1 col-3 mb-2 max-w-25rem">
                                            <label class="text-color-secondary">Style</label>

                                            <mvs-form-field
                                                    [formGroup]="widgetUiFields[i]"
                                                    [formField]="widgetUiFields[i].get('uiCssStyle').formField"
                                                    [hideLabel]="true"
                                            ></mvs-form-field>

                                        </div>

                                        <div
                                                *ngIf="visibleFields['uiStyle']"
                                                class="flex flex-column gap-1 col-3 mb-2">
                                            <label class="text-color-secondary">Inline Style</label>
                                            <input pInputText type="text" formControlName="uiStyle"/>
                                        </div>

                                        <div
                                                class="flex flex-column gap-1 col-3 mb-2 col-3 mb-2"
                                                *ngIf="handleIconFieldExists(i, 'uiOutputField') && visibleFields['iconSize']">
                                            <label class="text-color-secondary">Font Size</label>
                                            <p-selectButton

                                                    styleClass="active-select-button"
                                                    [options]="fontSizeEntries"
                                                    formControlName="iconSize"
                                                    optionValue="image">
                                                <ng-template #item let-item>
                                                    <div class="flex w-full justify-content-center align-items-center">
                                                    <span [pTooltip]="item.description">
                                                        {{ item.label }}
                                                    </span>
                                                    </div>
                                                </ng-template>
                                            </p-selectButton>
                                        </div>

                                        <div class="flex flex-column gap-1  col-3 mb-2">
                                            <label class="text-color-secondary">Colspan</label>
                                            <div class="flex align-items-center ml-2">
                                                <label
                                                        *ngIf="visibleFields['lgColspan']"
                                                        class="text-color-secondary">L</label>
                                                <input
                                                        *ngIf="visibleFields['lgColspan']"
                                                        class="mx-2" type="text" style="width:3rem" pInputText
                                                        formControlName="lgColspan"/>
                                                <label
                                                        *ngIf="visibleFields['mdColspan']"
                                                        class="text-color-secondary">M</label>
                                                <input
                                                        *ngIf="visibleFields['mdColspan']"
                                                        class="mx-2" type="text" style="width:3rem" pInputText
                                                        formControlName="mdColspan"/>
                                                <label
                                                        *ngIf="visibleFields['smColspan']"
                                                        class="text-color-secondary">S</label>
                                                <input
                                                        *ngIf="visibleFields['smColspan']"
                                                        class="mx-2" type="text" style="width:3rem" pInputText
                                                        formControlName="smColspan"/>
                                            </div>
                                        </div>

                                        <div
                                                *ngIf="visibleFields['uiEditable']"
                                                class="flex flex-column gap-1  col-3 mb-2">
                                            <label class="text-color-secondary">Editable</label>
                                            <p-toggle-switch
                                                    formControlName="uiEditable"></p-toggle-switch>
                                        </div>

                                        <div
                                                *ngIf="visibleFields['uiLabelIcon']"
                                                class="flex flex-column gap-1  col-3 mb-2">
                                            <label class="text-color-secondary">Label Icon</label>
                                            <p-toggle-switch
                                                    formControlName="uiLabelIcon"></p-toggle-switch>
                                        </div>

                                        <div class="flex flex-column gap-1  col-3 mb-2"
                                             *ngIf="visibleFields['uiLabelIcon']">
                                            <!--                    <mvs-form-field-icon [component]="widgetUiFields[i].get('uiInputIcon').value.component"-->
                                            <!--                                         [form]="form"-->
                                            <!--                                         [widgetUiField]="widgetUiFields[i]"></mvs-form-field-icon>-->
                                            <div class="p-inputgroup">
                                                <span class="p-inputgroup-addon">
                                                    <mvs-icon [icon]="getFieldValue(i,'uiLabelIconValue')">
                                                    </mvs-icon>
                                                </span>
                                                <input class="" type="text"
                                                       style="width:8rem"
                                                       pInputText
                                                       (paste)="onPasteIcon($event, i, 'uiLabelIconValue')"
                                                       formControlName="uiLabelIconValue"/>
                                                <span class="p-inputgroup-addon cursor"
                                                      [pTooltip]="'Redirect to Font Awesome'"
                                                      (click)="handleFontAwesomeRedirect()">
                                                    <mvs-icon icon="fa-solid fa-diamond-turn-right">
                                                    </mvs-icon>
                                                </span>
                                            </div>
                                        </div>

                                        <div
                                                *ngIf="
                    widgetUiFields[i]?.get('isGenericComponent')?.value ||
                    widgetUiFields[i]?.get('formField')?.value?.isGenericComponent"
                                                class="flex flex-column gap-1  col-3 mb-2">

                                            <p-button label="Remove Field"
                                                      (click)="handleDeleteField(widgetUiFields[i])"></p-button>
                                        </div>

                                        <div
                                                *ngIf="visibleFields['disabled']"
                                                class="flex flex-column gap-1  col-3 mb-2">
                                            <label class="text-color-secondary">Disabled</label>
                                            <p-toggle-switch
                                                    formControlName="disabled"></p-toggle-switch>
                                        </div>


                                        <div *ngIf="visibleFields['defaultValue']"
                                             class="flex flex-column gap-1  col-3 mb-2">
                                            <label class="text-color-secondary">Default Value</label>

                                            <mvs-form-field-wrapper
                                                    *ngIf="formFields[i]"
                                                    [formField]="formFields[i]"
                                                    [formGroup]="widgetUiFields[i]"
                                                    controlName="defaultValue"
                                                    (onChange)="updateFormFields()"
                                                    [hideLabel]="true"
                                            ></mvs-form-field-wrapper>
                                        </div>

                                        <div
                                                *ngIf="visibleFields['mostUsed']"
                                                class="flex flex-column gap-1  col-3 mb-2">
                                            <label class="text-color-secondary">Most Used</label>
                                            <p-toggle-switch
                                                    formControlName="mostUsed"></p-toggle-switch>
                                        </div>

                                        <div
                                                *ngIf="visibleFields['mostUsedFrequency']"
                                                class="flex flex-column gap-1  col-3 mb-2">
                                            <label class="text-color-secondary">Most Used Frequency</label>
                                            <input
                                                    pInputText
                                                    type="number"
                                                    formControlName="mostUsedFrequency">
                                        </div>

                                        <ng-container
                                                *ngIf="handleBoolIconField(i, 'uiOutputField')">
                                            <div *ngIf="visibleFields['uiBoolIconYes']"
                                                 class="flex flex-column gap-1 col-3 mb-2">
                                                <label class="text-color-secondary">Yes Icon</label>
                                                <div class="p-inputgroup col-10">
                                                <span class="p-inputgroup-addon">
                                                    <mvs-icon [icon]="getFieldValue(i,'uiBoolIconYes')">
                                                    </mvs-icon>
                                                </span>
                                                    <input class="" type="text"
                                                           style="width:8rem"
                                                           pInputText
                                                           (paste)="onPasteIcon($event, i, 'uiBoolIconYes')"

                                                           formControlName="uiBoolIconYes"/>
                                                    <span class="p-inputgroup-addon cursor"
                                                          [pTooltip]="'Redirect to Font Awesome'"
                                                          (click)="handleFontAwesomeRedirect()">
                                                    <mvs-icon icon="fa-solid fa-diamond-turn-right">
                                                    </mvs-icon>
                                                </span>
                                                </div>
                                            </div>

                                            <div
                                                    *ngIf="visibleFields['uiBoolIconNo']"
                                                    class="flex flex-column gap-1 col-3 mb-2">
                                                <label class="text-color-secondary">No Icon</label>
                                                <div class="p-inputgroup col-10">
                                                <span class="p-inputgroup-addon">
                                                    <mvs-icon [icon]="getFieldValue(i,'uiBoolIconNo')">
                                                    </mvs-icon>
                                                </span>
                                                    <input class="" type="text"
                                                           style="width:8rem"
                                                           pInputText
                                                           (paste)="onPasteIcon($event, i, 'uiBoolIconNo')"

                                                           formControlName="uiBoolIconNo"/>
                                                    <span class="p-inputgroup-addon cursor"
                                                          [pTooltip]="'Redirect to Font Awesome'"
                                                          (click)="handleFontAwesomeRedirect()">
                                                    <mvs-icon icon="fa-solid fa-diamond-turn-right">
                                                    </mvs-icon>
                                                </span>
                                                </div>
                                            </div>

                                            <div
                                                    *ngIf="visibleFields['uiBoolIconNull']"
                                                    class="flex flex-column gap-1 col-3 mb-2">
                                                <label class="text-color-secondary">Null Icon</label>
                                                <div class="p-inputgroup col-10">
                                                <span class="p-inputgroup-addon">
                                                    <mvs-icon [icon]="getFieldValue(i,'uiBoolIconNull')">
                                                    </mvs-icon>
                                                </span>
                                                    <input class="" type="text"
                                                           style="width:8rem"
                                                           pInputText
                                                           (paste)="onPasteIcon($event, i, 'uiBoolIconNull')"

                                                           formControlName="uiBoolIconNull"/>
                                                    <span class="p-inputgroup-addon cursor"
                                                          [pTooltip]="'Redirect to Font Awesome'"
                                                          (click)="handleFontAwesomeRedirect()">
                                                    <mvs-icon icon="fa-solid fa-diamond-turn-right">
                                                    </mvs-icon>
                                                </span>
                                                </div>
                                            </div>
                                        </ng-container>


                                    </div>

                                    <div>

                                    <ng-container *ngIf="widgetUiFields[i].get('uiOutputConfig').value">
                                        <h5>Output Field Config</h5>
                                        <config-component-wrapper
                                                [component]="widgetUiFields[i].get('uiOutputConfig').value.component"
                                                [formGroup]="formGroup"
                                                [form]="form"
                                                [widgetUiField]="widgetUiFields[i]"
                                                [widgetData]="widgetData"
                                                [formFields]="formFields">
                                        </config-component-wrapper>
                                    </ng-container>

                                    <ng-container *ngIf="widgetUiFields[i].get('uiInputConfig').value">
                                        <h5>Input Field Config</h5>
                                        <config-component-wrapper
                                                [component]="widgetUiFields[i].get('uiInputConfig').value.component"
                                                [formGroup]="formGroup"
                                                [form]="form"
                                                [widgetUiField]="widgetUiFields[i]"
                                                [widgetData]="widgetData"
                                                [formFields]="formFields">
                                        </config-component-wrapper>
                                    </ng-container>
                                    </div>

                                    <!--                                </div>-->
                                </td>


                            </tr>
                        </ng-container>

                    </ng-template>

                </p-table>
            </div>
    </form>

    <div class="flex justify-content-center my-3" *ngIf="widgetUiFieldsAll.length > widgetUiFields.length">
        <p-button
                label="Show more"
                icon="pi pi-angle-down"
                [disabled]="fieldsLoadingBusy"
                (click)="showMore()">
        </p-button>
    </div>

</ng-container>

<p-contextMenu [appendTo]="'body'"
               #cmTable
               [model]="fieldsContextMenuItems">

</p-contextMenu>



